import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import CookiePolicy from "./CookiePolicy";

const CookiePolicyModal = (props) => {
    return (
        <Modal
            {...props}
            show={props.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    COOKIE POLICY
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CookiePolicy showHeading={false}/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CookiePolicyModal;